import API_PATH from '../../../config/API_PATH'
import { LOGIN_STREAK_CLAIM, LOGIN_STREAK_RESET, LOGIN_STREAK_REVIVE, LOGIN_STREAK_STATUS } from './contants'

export const getStreakStatus = data => {
	return {
		type: LOGIN_STREAK_STATUS,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.loginStreakStatus,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const postLoginStreakClaim = data => {
	return {
		type: LOGIN_STREAK_CLAIM,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.loginStreakClaim,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const postLoginStreakRevive = data => {
	return {
		type: LOGIN_STREAK_REVIVE,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.loginStreakRevive,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const postLoginStreakReset = data => {
	return {
		type: LOGIN_STREAK_RESET,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.loginStreakReset,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
